<template>
  <div>
    <h3>Ressources humaines</h3>
    <table class="table table-sm">
      <thead>
        
        <tr>
          <th>Postes</th>
          <th style="text-align:center;border-top:0px">Nb</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Requis</td>
          <td style="text-align:center" v-text="humanresources.requis"></td>
        </tr>
        <tr>
          <td>Comblés</td>
          <td style="text-align:center" v-text="humanresources.combles"></td>
        </tr>
        <tr>
          <td>Écart</td>
          <td style="text-align:center" v-text="humanresources.ecart"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SPRequirementStatus',
  props: {
    humanresources: {},
  },

}
</script>
